/**
 * @module Field
 */

import Component from '../Component';
import '../../../images/sprite/view.svg';
import '../../../images/sprite/arrow.svg';
import './styles.css';

/**
 * Поле ввода.
 */
export default class Field extends Component {
    static className = 'field';

    init(options, renderOptions, pluginOptions) {
        super.init(options, renderOptions, pluginOptions);
        this.updateMarkup();
    }

    initElements() {
        this.elements = {
            $input: $('.field__input', this.$block),
        };
    }

    /**
     * Приводит разметку в соответствие параметрам.
     */
    updateMarkup() {
        if (this.elements.$input.val()) {
            this.$block.addClass('field--active');
        }
    }
}

$(document).on('focus', '.field__input', handleFocus);
$(document).on('blur', '.field__input', handleBlur);
$(document).on('click', '.field__password-btn', handlePasswordClick);

function handleFocus(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $field = $target.closest('.field');

    $field.addClass('field--active');
}

function handleBlur(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $target.closest('.field');

    const block = Field.getInstance($block);

    if (block && block.elements) {
        const { $input } = block.elements;

        /* Если открыт календарь, то ничего не делаем. В противном случае будет происходить скачок анимации label */
        if ($block.hasClass('field--calendar-opened')) {
            e.preventDefault();
            return;
        }

        if (!$input.val()) {
            $block.removeClass('field--active');
        }
    }
}

function handlePasswordClick(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $target.closest('.field');

    const block = Field.getInstance($block);
    const { $input } = block.elements;

    if ($input.attr('type') === 'password') {
        $input.attr('type', 'text');
    } else {
        $input.attr('type', 'password');
    }

    $target.toggleClass('field__password-btn--active');
}
